import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {AlertBox} from 'shells/alert-box/alert-box';
import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';

type Props = {
    onClose: () => void;
    planLimit: number | null | undefined;
};

export function LeadLimitModal(props: Props) {
    return (
        <AlertBox onClose={props.onClose}>
            <div className='pad-16'>
                <div className='mb-16'>
                    <div className='mb-8'>
                        <Header>Lead limit reached</Header>
                    </div>
                    <Body>
                        You have reached the maximum number of leads you can create with your plan{' '}
                        <Link
                            variant='primary'
                            // @ts-expect-error
                            as={RoutedLink}
                            to='/leads?sort=-age&filter[status][anyAll]=any&filter[status][data][0][data]=Open&view=list'
                        >
                            ({props.planLimit})
                        </Link>
                        . Upgrade your plan to {/* @ts-expect-error */}
                        <Link variant='primary' as={RoutedLink} to='/setup/billing/sales'>
                            Nutshell Growth or higher
                        </Link>{' '}
                        to create more leads.
                    </Body>
                </div>
                <div className='flex justify-sb align-center'>
                    <Button variant='text-secondary' onClick={props.onClose} noPadding={true}>
                        Not right now
                    </Button>
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        variant='button-primary'
                        onClick={() => {
                            props.onClose();
                        }}
                        to='/setup/billing/sales'
                    >
                        <div className='flex gap-4 align-center'>
                            <UpgradeArrowIcon color={colors.blue} size={12} />
                            Upgrade plan
                        </div>
                    </Link>
                </div>
            </div>
        </AlertBox>
    );
}
